import React from "react";

function Navbar(props){
    return(
      <div>
        <div id="nav" className="card text-center">
        <div className="card-header">
          <h2>Employee Directory</h2>
          <h6>Hover and click on the title headline to filter by name or use the search box to narrow your result</h6>
        </div>
    </div>
    <div id="green"></div><br></br>
    </div>
    );
    
}

export default Navbar;